import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function SuspendedPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="max-w-md mx-auto border-destructive/30">
        <CardHeader className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-destructive/10 flex items-center justify-center">
            <ShieldAlert className="h-8 w-8 text-destructive" />
          </div>
          <CardTitle className="text-xl">Votre accès a été suspendu</CardTitle>
          <CardDescription className="text-sm leading-relaxed mt-2">
            Un administrateur a temporairement suspendu votre accès à cet espace de travail.
            <br /><br />
            Cela signifie que vous ne pouvez plus accéder aux projets, documents et ressources de cet espace tant que votre accès n'est pas rétabli.
            <br /><br />
            Si vous pensez qu'il s'agit d'une erreur, veuillez contacter l'administrateur de votre organisation.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-3">
          <Button onClick={() => navigate('/onboarding')} className="w-full">
            Créer mon propre workspace
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={async () => {
              const { supabase } = await import('@/integrations/supabase/client');
              await supabase.auth.signOut();
              navigate('/auth');
            }}
          >
            Se déconnecter
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
